export const DATE_DD_MON_YEAR = 'dd-MMM-yyyy';
export const DATE_YEAR_MM_DD = 'yyyy-MM-dd';

export const DATE_DD_MON_YEAR_H_MM = 'dd-MMM-yyyy h:mm';
export const DATE_DD_MON_YEAR_HH_MM = 'dd-MMM-yyyy kk:mm';

export const TIME_KK_MM_SS = 'kk:mm:ss';
